var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("div", { staticClass: "simple-row" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c("swb-file-upload", {
                attrs: {
                  fileGroup: "image-goods",
                  onBeforeUpload: _vm.onBeforeUpload,
                  onProgress: _vm.onProgress,
                  onDone: _vm.onUploadDone,
                  multipleFile: false
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.appturnFileList.length > 0
          ? _c(
              "ul",
              { staticClass: "file-area input clearfix" },
              _vm._l(_vm.appturnFileList, function(appturnFile, index) {
                return _c(
                  "li",
                  { staticClass: "file-content clearfix" },
                  [
                    _c("swb-file-item", {
                      attrs: {
                        trackKey: index,
                        fileName: appturnFile.fileName,
                        fileUuid: appturnFile.fileUuid,
                        fileBrowseUrl: appturnFile.fileBrowseUrl,
                        fileDownloadUrl: appturnFile.fileDownLoadUrl,
                        fileMd5: appturnFile.fileMd5,
                        deletable: true,
                        onDelete: _vm.deleteFile
                      }
                    }),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        title: appturnFile.fileName,
                        placeholder: "请输入文件名称"
                      },
                      on: {
                        input: function($event) {
                          _vm.changeFileName(index)
                        }
                      },
                      model: {
                        value: appturnFile.fileName,
                        callback: function($$v) {
                          _vm.$set(appturnFile, "fileName", $$v)
                        },
                        expression: "appturnFile.fileName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt5" }, [
                      appturnFile.tagName != null
                        ? _c(
                            "i",
                            { staticClass: "swb-tags swb-tags-success mr5" },
                            [_vm._v(_vm._s(appturnFile.tagName))]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt5" }, [
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.setTag($event, index)
                            }
                          }
                        },
                        [_vm._v("设置标签")]
                      ),
                      _vm._v(" "),
                      appturnFile.tagName != null
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeCancel(index)
                                }
                              }
                            },
                            [_vm._v("移除标签")]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              })
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        { ref: "attPopoverRef", attrs: { classes: "popper-tabs" } },
        [
          _c("swb-att-tag-list-for-select", {
            ref: "swb_att_tag_list_for_select",
            attrs: { attAspect: _vm.attAspect, selectName: _vm.tagName },
            on: {
              "notity-attTag-comfirm": _vm.doAttTagConfirm,
              "notity-attTag-cancel": _vm.doAttTagCancel
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint block" }, [
      _c("p", [
        _c("i", { staticClass: "icon iconfont icon-tongzhi1 mr10 font-gold" }),
        _c("span", [_vm._v("提示:最多上传20个附件，上传附件大小不可超过5M")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7859ce70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7859ce70","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shareAcc/AdjustApplyFormFileUpload.vue
// module id = 2818
// module chunks = 0